import React from 'react';
import { Check } from 'lucide-react';

const steps = ['Details', 'Plan', 'Setup'];

export const TrialProgress = ({ current }) => (
  <ol className="trial-progress" aria-label="Signup progress" data-testid="trial-step-indicator">
    {steps.map((label, index) => <li key={label} className={index + 1 === current ? 'is-current' : index + 1 < current ? 'is-complete' : ''} aria-current={index + 1 === current ? 'step' : undefined} data-testid={`trial-progress-${label.toLowerCase()}`}>
      <span className="trial-progress-mark" aria-hidden="true">{index + 1 < current ? <Check size={11} /> : index + 1}</span>
      <span>{label}</span>
    </li>)}
  </ol>
);